import React, { useState, useEffect } from 'react';
import styles from '../../TransferPage.module.scss';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import { transcationActions } from '../../../../stores/_actions';
import { Button } from 'semantic-ui-react';
import { Transcation } from '../../../common/transcation/Transcation';
import { NoRecord } from '../../../common/norecord/norecord';
const Print = (props) => {
  const location = useLocation();
  const history = useHistory();
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const refno = JSON.parse(localStorage.getItem('refno'));
  const saveRemittance = useSelector((state) => state.saveRemit);
  const referenceNo = saveRemittance.data == undefined ? refno : saveRemittance.data?.response.Refno;
  const dispatch = useDispatch();
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
      ReferenceNo: referenceNo,
    },
    Status: false,
    SessionID: null,
    IdType: null,
  };

  useEffect(() => {
    setTimeout(async () => {
      await dispatch(transcationActions.getTransactionSearchByRefno(payload));
    }, 2000);
  }, []);

  let transcationListData;
  let status;
  let loading = null;
  useSelector((state) => {
    transcationListData = state.getTransactionRef?.data;
    status = state.getTransactionRef?.getTranscation;
    loading = state.getTransactionRef?.loading;
    // setData((transcationListData) => (transcationListData = transcDataList))
    // transcDataList = state.getTransactionRef?.data;
  }, []);

  const [buttonActive, setButtonActive] = useState(false);

  const redirect = () => {
    const menu = {
      beneficiary: true,
      amount: false,
      payment: false,
      confirm: false,
      transfer: false,
      print: false,
    };
    const menuValue = {
      ...props.active,
      menu,
      buttonActive,
    };
    localStorage.removeItem('refno');
    history.push({ pathname: '/transfer', state: menuValue });
  };
  const print = () => {
    window.print();
  };

  const benefData = location?.state?.items;
  return (
    <>
      {loading ? (
        <div style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '20px' }}>Loading...</div>
      ) : transcationListData ? (
        <Transcation transcationListData={transcationListData} benefData={benefData} styles={styles} />
      ) : (
        loading && <NoRecord status={status} />
      )}
      {loading == undefined && <div style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '20px' }}>Loading...</div>}
      <div className={styles.pageLeft__buttonCenter}>
        <Button onClick={print}>Print</Button>
        <Button onClick={redirect}> Make Another Transcation </Button>
      </div>
    </>
  );
};

export default Print;
